import React from 'react';
import PropTypes from 'prop-types';

import { st, classes } from './SidebarDividerNext.st.css';
import Divider from '../Divider';
import { SidebarNextContext } from '../SidebarNext/SidebarNextContext';
import { skins } from './constants';
import { WixStyleReactContext } from '../WixStyleReactProvider/context';

/** A divider within the sidebar that supports inner and full mode */
class SidebarDividerNext extends React.PureComponent {
  static displayName = 'SidebarDividerNext';

  static propTypes = {
    /** Applied as data-hook HTML attribute that can be used in the tests */
    dataHook: PropTypes.string,
    /** Indicates whether to remove the margin from sides */
    fullWidth: PropTypes.bool,
  };

  render() {
    const { dataHook, fullWidth } = this.props;

    return (
      <WixStyleReactContext.Consumer>
        {() => (
          <SidebarNextContext.Consumer>
            {context => {
              const skin = (context && context.skin) || skins.dark;

              return (
                <div
                  data-hook={dataHook}
                  data-skin={skin}
                  data-full-width={fullWidth}
                  className={st(
                    classes.root,
                    fullWidth ? classes.fullWidth : '',
                  )}
                  aria-hidden="true"
                >
                  <Divider className={st(classes.divider, { skin })} />
                </div>
              );
            }}
          </SidebarNextContext.Consumer>
        )}
      </WixStyleReactContext.Consumer>
    );
  }
}

export default SidebarDividerNext;
